import React, {useState} from "react";
import ReactDOM from "react-dom";
import LanguageContext from "../../../helper/LanguageContext";
import {BASE_URL} from "../../../helper/constants";
import {Form} from "react-bootstrap";
import {DE} from "../../../Languages/DE";
import {EN} from "../../../Languages/EN";

import '../../../styles/pages.css';

export default function CompanyListDialog({handleClose, setParam, companies, handleReJoinCompany, requestId = null, isInternal = false}) {
    const {isGerm, strings} = React.useContext(LanguageContext);
    const [allCompanies, setAllCompanies] = useState(companies);
    const [search, setSearch] = useState('');
    const [company, setCompany] = useState('');
    const handleChangeValue = async (company) => {
        setParam('companyId', company.id);
        setParam('companyName', company.name);
        setParam('companySelect', true);
        setCompany(company);
        console.log(requestId);
        handleReJoinCompany(company, requestId);
        // For internal chat flow, don't call handleClose as the parent handles navigation
        // This prevents race conditions between closing the dialog and navigating
        if (!isInternal) {
            handleClose();
        }
    }

    const companyFilter = (value) => {
        setSearch(value)
        const filterCompanies = allCompanies.filter(company => {
            if (value === "") {
                return company;
            } else if (company.name?.toLowerCase().includes(value?.toLowerCase())) {
                return company;
            }
        })
        if (value === "") {
            console.log(companies);
            setAllCompanies(companies)
        } else {
            setAllCompanies(filterCompanies)
        }
    }

    // Use Portal to render outside of component hierarchy to escape stacking context issues
    return ReactDOM.createPortal(
        <div 
            className="popup-backdrop"
            onClick={(e) => {
                if (e.target.classList.contains('popup-backdrop')) {
                    handleClose();
                }
            }}
        >
            <div 
                className={`role_popup role_popup_right popup-clean${isInternal ? ' popup-internal' : ''}`}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="popup-header">
                    <h6>{isInternal 
                        ? (strings.select_internal_section)
                        : (strings.select_with_which_company_you_want_to_connect_to_the_project)
                    }</h6>
                    <button
                        type="button"
                        onClick={handleClose}
                        className={`kj-btn kj-btn--icon kj-btn--sm kj-btn--neutral${isInternal ? ' kj-btn--internal' : ''}`}
                    >
                        ✕
                    </button>
                </div>
                <div className="role_data mb-0">
                    <div className="search">
                        <Form.Group controlId="exampleForm.ControlInput1">
                            <Form.Control value={search} autoComplete="off" type="search"
                                          placeholder={strings.search}
                                          onChange={e => companyFilter(e.target.value)}/>
                        </Form.Group>
                    </div>
                    <ul className="list-group">
                        {
                            allCompanies.map(company =>
                                <li 
                                    key={company.id} 
                                    className="list-group-item"
                                    onClick={() => handleChangeValue(company)}
                                >
                                    <img width={36} height={36}
                                         src={company.logo ? BASE_URL + company.logo : process.env.PUBLIC_URL + "/assets/img/Companies-No-Image-Round.svg"}
                                         alt="company Logo" className="float-left"/>
                                    <div className="company-info">
                                        <span className="company-name">{company.name}</span>
                                        <span className="select-arrow">›</span>
                                    </div>
                                </li>
                            )
                        }
                    </ul>
                </div>
            </div>
        </div>,
        document.body
    )
}
